














































































































































































































































































































import {Vue, Component} from 'vue-property-decorator';

@Component
export default class FooterServicePrivacy extends Vue {
  private onClickNext() {
    this.$router.push({name: 'FooterServicePrivacy', query: {ver: '20200214'}});
    window.scrollTo(0, 0);
  }
}
